import { User } from '../../../user/types';
import { Form } from 'react-bootstrap';
import { ProgramOwnerSelect } from '../ProgramOwnerSelect';
import { ModalDropdownMenuZIndex } from '../../util';
import React from 'react';

export const ProgramEditOwner = ({
  setValue,
  value,
  disabled,
}: {
  setValue: (s: User | null) => void;
  value: User | null;
  disabled: boolean;
}) => (
  <Form.Group controlId="owner" className="growegy-form__row">
    <label className="growegy-form__label">Owner</label>
    <div className="growegy-form__owner-container">
      <ProgramOwnerSelect
        initialValue={value}
        onValueChange={(v) => setValue(v)}
        dataTestPrefix="program-owner-select"
        menuZIndex={ModalDropdownMenuZIndex}
        disabled={disabled}
      />
    </div>
  </Form.Group>
);
